var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPropCancellation = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_729_30513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.91823 2.10133L6.91822 2.10132L6.91651 2.10418L1.62276 10.9417L1.6227 10.9416L1.61789 10.95C1.45635 11.2297 1.37088 11.5469 1.36998 11.8699C1.36907 12.1929 1.45277 12.5106 1.61273 12.7912C1.7727 13.0718 2.00336 13.3057 2.28177 13.4695C2.56017 13.6334 2.87663 13.7214 3.19964 13.725L3.19964 13.725H3.20623H13.7937V13.725L13.8003 13.725C14.1233 13.7214 14.4398 13.6334 14.7182 13.4695C14.9966 13.3057 15.2273 13.0718 15.3872 12.7912C15.5472 12.5106 15.6309 12.1929 15.63 11.8699C15.6291 11.5469 15.5436 11.2297 15.3821 10.95L15.3821 10.9499L15.3772 10.9417L10.0835 2.10418L10.0835 2.10418L10.0817 2.10133C9.91683 1.82948 9.68465 1.60471 9.40759 1.44873C9.13053 1.29274 8.81794 1.21079 8.49998 1.21079C8.18203 1.21079 7.86944 1.29274 7.59238 1.44873C7.31532 1.60471 7.08313 1.82948 6.91823 2.10133Z",
    stroke: "#D14141",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5151 7L6.5 11",
    stroke: "#D14141",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5151 11L6.5 7",
    stroke: "#D14141",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_729_30513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 15,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPropCancellation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/prop-cancellation.ac249d7792027e2f3c6da88f289f32a3.svg";